module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09B1N4WT3.0a0b453b.jpg";